import { Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SelectedEntityItem from '~components/data/selectedEntityItem';
import VirtualizedList from '~components/data/virtualizedList';
import VectorImage from '~components/media/vectorImage';
import Device from '~interfaces/device';
import { Dimens } from '~themes';
import { ifNullOrEmpty } from '~utils/stringUtils';

interface Props {
	selectedDevices: Device[];
	onRemoveClicked: (device: Device) => void;
}

const SelectedDevicesOverview = ({ selectedDevices, onRemoveClicked }: Props) => {
	const { t } = useTranslation();
	const { palette } = useTheme();
	const shouldVirtualize = selectedDevices.length >= 20;

	return (
		<Stack
			direction='column'
			sx={{
				width: {
					xs: '100%',
					sm: '500px',
				},
			}}
		>
			<Stack direction='row' gap={Dimens.spacingMd}>
				<VectorImage name='icon/device' />
				<Typography variant='label' color={palette.textPrimary.main}>
					{t('device.labels.selectedDevices', { ns: 'entities' })} ({selectedDevices.length})
				</Typography>
			</Stack>
			{shouldVirtualize ?
				<VirtualizedList
					items={selectedDevices}
					getItemKey={(device) => device.id}
					rowHeight={50}
					maxHeight={440}
					overscan={12}
					renderItem={(device) => (
						<SelectedEntityItem
							entityName={device.name}
							entityId={ifNullOrEmpty(device.hardwareId)}
							onRemoveClicked={() => onRemoveClicked(device)}
						/>
					)}
				/>
			:	<Stack direction='column' sx={{ maxHeight: 440, overflowY: 'auto' }}>
					{selectedDevices.map((device) => (
						<SelectedEntityItem
							key={device.id}
							entityName={device.name}
							entityId={ifNullOrEmpty(device.hardwareId)}
							onRemoveClicked={() => onRemoveClicked(device)}
						/>
					))}
				</Stack>
			}
		</Stack>
	);
};

export default SelectedDevicesOverview;
